var React = require('react/addons');
var cx = require('classnames');
var RangePicker = require('react-daterange-picker');
var moment = require('ofs/moment');
var Fluxxor = require('fluxxor');

var FluxMixin = Fluxxor.FluxMixin(React);


var CalendarPopover = React.createClass({
  mixins: [
    FluxMixin
  ],

  getInitialState: function() {
    return {
      value: this.props.value
    };
  },

  handleSelect: function(value) {
    this.setState({value});
    this.props.handleSelect(value);
    this.getFlux().actions.layers.remove();
  },

  render: function(trigger) {
    var value = this.state.value;
    var yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    return (
      <div className="datepicker">
        <RangePicker
          bemNamespace="ofs"
          bemBlock="DatePicker"
          selectionType="single"
          value={value}
          numberOfCalendars={1}
          firstOfWeek={1}
          onSelect={this.handleSelect}
          earliestDate={yesterday} />
      </div>
    );
  }
});


var Datepicker = React.createClass({
  mixins: [
    FluxMixin
  ],

  getInitialState: function() {
    var value;

    if (this.props.value) {
      value = moment(this.props.value);
    }
    return {
      value: value
    };
  },

  showPicker: function(event) {
    var trigger = $(this.getDOMNode()).find('.faux-input');
    this.getFlux().actions.layers.addPopover(<CalendarPopover
      trigger={trigger}
      handleSelect={this.handleSelect}
      value={this.state.value} />);
  },

  handleSelect: function(value) {
    this.setState({
      value: value
    });
    if(this.props.handleSelect && typeof this.props.handleSelect === "function") {
      this.props.handleSelect(value);
    }
  },

  render: function() {
    var value = this.state.value;

    var displayValue = null;
    var formValue = null;

    if (value) {
      displayValue = moment(value).longDateFormat();
      formValue = moment(value).isoDateFormat();
    }

    var inputClasses = cx({
      'ofs-Input faux-input': true,
      'focused': this.state.shown
    });

    return (
      <div className="react-datepicker">
        <input name={this.props.name} type="hidden" value={formValue} />
        <div onClick={this.showPicker} className={inputClasses}>
          {displayValue ? <span className="value">{displayValue}</span> : <span className="placeholder">Select date</span>}
        </div>
      </div>
    );
  }
});

module.exports = Datepicker;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/datepicker.jsx
 **/